import React from "react";

import { PAGE_TYPES, PAGE_TYPE_INFO } from "./pageKinds";

/**
 * Choix du type au moment de CRÉER une page.
 *
 * POURQUOI CET ÉCRAN EXISTE. Créer une page ouvrait le composeur sur une page
 * de contexte, sans le dire : le type se changeait ensuite dans un menu de
 * l'onglet Fiche, que rien ne désignait. Une mosaïque commencée « en contexte »
 * ne se voyait donc qu'au moment de chercher où poser ses décisions.
 *
 * Le type est ce qui décide de TOUT le reste de l'écran — quels onglets
 * existent, quels champs sont proposés, ce que le participant peut faire. Il se
 * choisit donc avant d'entrer, comme la forme d'une étape (cf. StepTypePicker),
 * et reste modifiable ensuite depuis l'onglet Fiche.
 *
 * `blocked` : les types que ce contexte refuse, `{ type: raison }`. La carte
 * reste VISIBLE et porte sa raison — un type absent de la grille ferait croire
 * qu'il n'existe pas, là où il manque seulement une carte à l'atelier.
 */
export default function PageTypePicker({ onPick, onCancel, onBack, blocked = {} }) {
  return (
    <div className="builder-picker-overlay" onClick={onCancel}>
      <div className="step-typepicker" onClick={(e) => e.stopPropagation()}>
        <div className="builder-picker-header">
          <h3>
            {onBack && (
              <button type="button" className="page-typepicker-back" onClick={onBack}>
                ← Retour
              </button>
            )}
            Quel type de page ?
          </h3>
          <button onClick={onCancel}>✕</button>
        </div>
        <p className="step-editor-section-hint" style={{ padding: "0 20px" }}>
          Ce que la page fait faire au participant. Le type décide des réglages proposés
          ensuite ; il reste modifiable depuis l'onglet Fiche.
        </p>
        <div className="step-picker-grid step-picker-grid--wide page-typepicker-grid" style={{ padding: 20 }}>
          {PAGE_TYPES.map((type) => {
            const info = PAGE_TYPE_INFO[type];
            const reason = blocked[type];
            return (
              <button
                key={type}
                type="button"
                className={`step-picker-card page-type-card${reason ? " is-blocked" : ""}`}
                disabled={!!reason}
                title={reason || info.description}
                onClick={() => !reason && onPick(type)}
              >
                <span className="page-type-icon" style={{ background: `${info.color}1f`, color: info.color }}>
                  {info.icon}
                </span>
                <span className="step-picker-label">{info.label}</span>
                <span className="step-picker-hint">{reason || info.short}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
